import * as React from "react";
export const TriangleArrowIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg data-name="Layer 1" viewBox="0 0 12 6" {...props}>
    <path data-name="Combined-Shape" d="M12 0L6 6 0 0z" />
  </svg>
);
